import { LEADERBOARD_TABS } from "../../constants";
import { useAppSelector } from "../../hooks/store-hooks";
import { ShoppingBag } from "../../icons";
import Chip from "../common/chip";

const LeaderBoardHeader = ({
  type,
  setType,
}: {
  type: string;
  setType: any;
}) => {
  const { homeData } = useAppSelector((state: any) => state.home || {});
  const { account_balances } = homeData || {};
  return (
    <div className="px-4 md:px-0">
      <div className="flex items-center justify-between">
        <div className="text-[#090909] text-3xl font-bold">Leaderboard</div>
        <div className="flex items-center justify-end gap-4 md:hidden">
          <ShoppingBag size="26" />
          <div className="h-[30px] px-2 py-1 bg-[#ebebeb] rounded-[20px] border border-[#e1e1e1] inline-flex gap-1 items-center justify-between">
            <img
              src="/assets/logo/OneGoldCoin.png"
              alt=""
              className="w-4 h-4"
            />
            {account_balances?.coins || 0}
          </div>
        </div>
      </div>
      <div className="flex justify-between mt-4 md:mt-8">
        <div className="flex justify-start gap-3">
          {LEADERBOARD_TABS.map((chip, index) => {
            return (
              <Chip type={type} text={chip} setType={setType} key={index} />
            );
          })}
        </div>
        <div className="items-center justify-end hidden gap-4 md:flex">
          <div className="h-[30px] px-2 py-1 bg-[#ebebeb] rounded-[20px] border border-[#e1e1e1] inline-flex gap-1 items-center justify-between">
            <img
              src="/assets/logo/OneGoldCoin.png"
              alt=""
              className="w-4 h-4"
            />
            {account_balances?.coins || 0}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderBoardHeader;
